var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 5.35659C10.3213 8.02444 5.4999 14.4637 5.4999 14.4637C5.4999 14.4637 0.678467 8.02444 0.678467 5.35659C0.678467 4.07786 1.18644 2.85151 2.09063 1.94732C2.99482 1.04313 4.22117 0.535156 5.4999 0.535156C6.77862 0.535156 8.00497 1.04313 8.90916 1.94732C9.81335 2.85151 10.3213 4.07786 10.3213 5.35659V5.35659Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49997 6.96429C6.38757 6.96429 7.10711 6.24474 7.10711 5.35714C7.10711 4.46954 6.38757 3.75 5.49997 3.75C4.61236 3.75 3.89282 4.46954 3.89282 5.35714C3.89282 6.24474 4.61236 6.96429 5.49997 6.96429Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.63c5707df7ca2bfd16e48312ad93c503.svg";
export { ForwardRef as ReactComponent };